(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header2"]) return;
  try {
    
  (function () {
    /* ------------------------------
       1) Simplified StickyHeader
       - Preserves sticky class but DOES NOT hide/reveal header on scroll
       - Keeps compatibility with other code that may expect .shopify-section-header-sticky
    ------------------------------- */
    class StickyHeaderSimple extends HTMLElement {
      constructor() { super(); }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.setHeaderHeight();

        // update on resize breakpoint changes
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        this.createObserver();
      }

      setHeaderHeight() {
        const headerEl = this.header;
        if (!headerEl) return;
        document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
      }

      createObserver() {
        if (!this.header) return;
        let observer = new IntersectionObserver((entries) => {
          if (!entries || entries.length === 0) return;
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }
    }
    customElements.define('sticky-header', StickyHeaderSimple);

    /* ------------------------------
       2) Auto-detect hero (first major content block) & toggle header background
       - Strategy: detect a "hero" element by trying selectors with fallback
       - Use IntersectionObserver to watch when hero bottom crosses viewport top
    ------------------------------- */

    function findHeroElement() {
      // First try: main > * (first child)
      const main = document.querySelector('main');
      if (main && main.firstElementChild) {
        return main.firstElementChild;
      }

      // Next try common hero/selectors
      const selectors = [
        '.hero',
        '.slideshow',
        '.section--hero',
        '.banner',
        '.page-hero',
        'section'
      ];
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (el) return el;
      }

      // fallback to body (so header becomes white after tiny scroll)
      return document.body;
    }

    function initHeaderBackgroundToggle() {
      const header = document.querySelector('.header');
      if (!header) return;

      const hero = findHeroElement();
      let isPastHero = false;

      // IntersectionObserver to detect when hero bottom crosses the top of viewport
      const io = new IntersectionObserver((entries) => {
        // if intersecting = hero is visible -> keep transparent
        // when not intersecting at root: hero is out of view -> make header white
        entries.forEach(entry => {
          // entry.isIntersecting true means some of hero is visible
          if (entry.isIntersecting) {
            // hero visible -> header should be transparent unless hovered
            isPastHero = false;
            header.classList.remove('header--white');
          } else {
            // hero not visible -> header should be white
            isPastHero = true;
            header.classList.add('header--white');
          }
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      });

      // Observe the hero element itself (we care when it's visible)
      io.observe(hero);

      // Hover handlers: always show white on hover; on leave, restore based on isPastHero
      header.addEventListener('mouseenter', () => {
        header.classList.add('is-hovering');
        header.classList.add('header--white');
      });
      header.addEventListener('mouseleave', () => {
        header.classList.remove('is-hovering');
        if (!isPastHero) {
          header.classList.remove('header--white');
        } else {
          header.classList.add('header--white');
        }
      });

      // If the page loads already scrolled past hero (e.g., link to anchor), run a manual check
      // (use requestAnimationFrame to wait until layout)
      requestAnimationFrame(() => {
        const heroRect = hero.getBoundingClientRect();
        if (heroRect.bottom <= 0) {
          isPastHero = true;
          header.classList.add('header--white');
        } else {
          isPastHero = false;
          header.classList.remove('header--white');
        }
      });
    }

    /* ------------------------------
       3) Menu toggle behaviors (desktop)
       - toggles aria-expanded, shows submenu/mega-menu, closes on click outside or Escape
    ------------------------------- */
    function initMenuToggles() {
      const menu = document.getElementById('main-menu');
      if (!menu) return;

      // click on top-level buttons
      menu.querySelectorAll('.list-menu__item').forEach(item => {
        const btn = item.querySelector('.menu-top-btn');
        if (!btn) return;
        const hasChildren = btn.getAttribute('data-has-children') === 'true';

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = item.getAttribute('aria-expanded') === 'true';

          // close others
          menu.querySelectorAll('.list-menu__item').forEach(i => {
            i.setAttribute('aria-expanded', 'false');
            const b = i.querySelector('.menu-top-btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (hasChildren && !isOpen) {
            item.setAttribute('aria-expanded', 'true');
            btn.setAttribute('aria-expanded', 'true');
          } else {
            item.setAttribute('aria-expanded', 'false');
            btn.setAttribute('aria-expanded', 'false');
          }
        });

        // keyboard support: close on Escape while focused
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            item.setAttribute('aria-expanded', 'false');
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();
          }
        });
      });

      // close on click outside
      document.addEventListener('click', (e) => {
        if (!menu.contains(e.target)) {
          menu.querySelectorAll('.list-menu__item').forEach(i => {
            i.setAttribute('aria-expanded', 'false');
            const b = i.querySelector('.menu-top-btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }

    /* ------------------------------
       kick things off when DOM ready
    ------------------------------- */
    document.addEventListener('DOMContentLoaded', function () {
      initHeaderBackgroundToggle();
      initMenuToggles();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
